import baseApi from "./baseApi"

export default  {
    /**
     * Fetch Location GeoJSON Data
     * @param {int} locationID 
     * @return {GeoJSON}
     */
    async getLocationGeoJSONData(locationID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/locations/GeoJSON/" + locationID);
        return result.data;
    },
    /**
     * Set Location GeoJSON Data
     * @param {int} locationID 
     * @param {GeoJSON} GeoJSON 
     * @return {boolean}
     */
    async setLocationGeoJSONData(locationID, GeoJSON) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post('/locations/GeoJSON/' + locationID, GeoJSON);
        return result.data;
    },
    /**
     * Get Location Details for map view
     * @param {int} locationID 
     */
    async getTodaysHarvestOverview(locationID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get('/locations/GetTodaysHarvestOverview/' + locationID);
        return result.data;
    },
    /**
     * Get Location Details for map view
     * @param {int} locationID 
     */
        async getTodaysNuPointSprayOverview(locationID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get('/locations/GetTodaysNuPointSprayOverview/' + locationID);
        return result.data;
    },
    /**
     * Get all Locations     
     */
    async getLocations() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get('/locations');
        return result.data;
    },
    /**
     * Get Season Total
     */
    async getSeasonTotal(locationID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get('/locations/SeasonTotal/' + locationID);
        return result.data;
    }
}